import { apiGet } from "../utils/api";
import { fillterName, treeAddCrumbs } from "../utils/tools";

export const getTrees = () => {
  return apiGet("/publish/show/getTrees", {}).then((rs) => {
    let obj = {};
    if (rs.data.success) {
      let data = rs.data.data;
      obj.tabTitles = [];
      obj.treeList = {};
      data.forEach((dt) => {
        const { type, typeText, treeNodes } = dt;
        obj.tabTitles.push({ type, typeText, name: typeText });
        treeAddCrumbs(treeNodes, typeText, type);
        obj.treeList[type] = treeNodes;
      });
    }
    return obj;
  });
};

export const getTableHeadData = (params) => {
  return apiGet("/publish/show/getCols", params).then((rs) => {
    let arr = [];
    if (rs.data.success) {
      arr = rs.data.data; // array
      arr.forEach((item) => {
        let code = item.colCode;
        item.colStr = code;
        if (item.periods && item.periods.length > 0) {
          item.periods.forEach((period) => {
            period.colStr = code + "-" + period.colCode;
            period.cityTimeName = item.colName;
            period.cityTimeCode = code;
            period.cityTimeStr = item.colStr;
          });
        }
      });
    }
    return arr;
  });
};

export const getTableData = (params, theadData) => {
  const { id, ndjd } = params;
  // 处理配置文件中indicEcharts
  let configIndicEchart = indicEcharts.find((v) => v.id == id && v.type == ndjd);

  return apiGet("/publish/show/getDataByTime", params).then((rs) => {
    let data = { rs: [], chartData: {}, data: [], theadDataSort: [] };
    if (rs.data.success && rs.data.message == "成功") {
      // 2022.06.02 优化 --------------------------------
      let theadCols = [];
      theadData.forEach((v) => {
        if (v.periods && v.periods.length > 0) {
          theadCols.push(...v.periods);
        }
      });

      // 表头数据顺序
      let isTf = true;
      theadData.forEach((v) => {
        if (v.periods && v.periods.length > 0 && isTf) {
          v.periods.forEach((m) => data["theadDataSort"].push(m.colName));
          isTf = false;
        }
      });
      // 2022.06.02 优化 --------------------------------
      let tbodyData = (data.rs = rs.data.data);
      tbodyData.forEach((row) => {
        const { colCode, colName, children } = row; // time or city
        let obj = { colCode, [params.searchType]: colName };
        children.forEach((child) => {
          if (child) {
            let areaCode = child.colCode;
            if (child.periods && child.periods.length > 0) {
              child.periods.forEach((period) => {
                obj[areaCode + "-" + period.colCode] = period.value;
                obj["unit"] = period.unit;
              });
            }
          }
        });
        data.data.push(obj);
      });

      // 图表数据源
      let xAxisData = [];
      let list = [];
      // 扁平化处理
      tbodyData.forEach((row) => {
        let timeName = row.colName;
        let timeCode = row.colCode;
        let children = row.children;
        xAxisData.push(timeName);
        children.forEach((child) => {
          if (child) {
            let cityName = child.colName;
            let cityCode = child.colCode;
            let periods = child.periods;
            periods.forEach((period) => {
              let theadFirstRowName = fillterName(theadCols, cityCode + "-" + period.colCode, "cityTimeName");
              let theadSecRowName = fillterName(theadCols, cityCode + "-" + period.colCode, "colName");
              if (theadFirstRowName || theadSecRowName) list.push({ ...period, timeName, timeCode, cityName, cityCode, theadSecRowName, theadFirstRowName });
            });
          }
        });
      });
      params.searchType == "time" && xAxisData.reverse();
      // 按照时间/城市  处理成键值对形式
      list.forEach((ls) => {
        if (Object.keys(data.chartData).includes(ls.cityCode)) data.chartData[ls.cityCode].push(ls);
        else data.chartData[ls.cityCode] = [ls];
      });
      for (const key in data.chartData) {
        let obj = data.chartData[key];
        let arr = {};
        obj.forEach((ls) => {
          let thdColName = ls.theadSecRowName;
          let colname = thdColName != "" ? thdColName : ls.colName;

          // 根据配置文件，设置固定的指标不显示某些时点数据
          if (configIndicEchart && configIndicEchart.text.includes(colname)) {
            // 根据配置文件，设置固定的指标不显示某些时点数据
          } else {
            if (Object.keys(arr).includes(colname)) {
              arr[colname]["data"].push(ls);
            } else {
              let unti2 = ls.unit.indexOf("%") >= 0 || ls.unit == "无" ? "" : `[${ls.unit}]`;
              arr[colname] = { data: [ls], unit: `${ls.theadFirstRowName}[${colname}]${unti2}` };
            }
          }
        });
        data.chartData[key] = arr;

        for (const key1 in arr) {
          let dt1 = arr[key1];
          dt1.chartData = [];
          xAxisData.forEach((time) => {
            let obj1 = dt1.data.find((v) => v.timeName == time);
            dt1.chartData.push(obj1 ? Number(obj1.value) : "");
          });
        }
      }
      data.chartData.xAxisData = xAxisData;
    }

    return data;
  });
};

export const getTargetDesc = (params) => {
  return apiGet("/publish/show/getDesc", params).then((rs) => {
    let data = "";
    if (rs.data.success && rs.data.message == "成功") {
      data = rs.data.data;
    }
    return data;
  });
};
